import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const parentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getParents: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, `/api/parent`),
      }),
      providesTags: ["Paginated-Parents"],
    }),
  }),
});

export const { useGetParentsQuery } = parentApi;
